// Cloud Run multi-container deploy: SPA + API share one origin (nginx
// reverse-proxies /api/* to the Node sidecar). A relative server makes
// `BackService` / `api.config.ts` produce paths like `/api/auth/log-in`
// that resolve against whatever origin the SPA was loaded from.
//
// Selected via `ng build --environment=cloud-run` in Dockerfile.client.
// Local dev and e2e continue to use environment.ts (absolute server URL,
// rewritten by Playwright route interception in e2e).
export const environment = {
  production: true,
  server: '',
  upload_prefix: ''
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts